export default "__VITE_ASSET__Dfybmp7V__"